
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem('cookie_consent', 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/30 z-[9998] transition-opacity duration-500" />

      {/* Banner */}
      <div className="fixed bottom-0 left-0 right-0 z-[9999] animate-slide-up">
        <div className="bg-white border-t border-gray-200 shadow-2xl px-4 md:px-8 lg:px-16 py-6 md:py-8">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-5 md:gap-8">
              {/* Icon + Text */}
              <div className="flex items-start gap-4 flex-1">
                <div className="w-12 h-12 min-w-[48px] bg-[#C9A961]/10 rounded-full flex items-center justify-center mt-0.5">
                  <i className="ri-shield-check-line text-2xl text-[#C9A961]"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-lg font-bold text-[#1A2B4A] mb-1.5">
                    Respect de votre vie privée
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Ce site utilise des cookies strictement nécessaires à son fonctionnement et à la mesure d'audience anonymisée. Aucune donnée personnelle n'est partagée avec des tiers.
                    <Link
                      to="/confidentialite"
                      className="text-[#C9A961] hover:underline ml-1 font-medium"
                    >
                      En savoir plus
                    </Link>
                  </p>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex items-center gap-3 w-full md:w-auto">
                <button
                  onClick={handleRefuse}
                  className="flex-1 md:flex-none px-6 py-2.5 border border-gray-300 text-gray-700 rounded-full text-sm font-semibold hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  Refuser
                </button>
                <button
                  onClick={handleAccept}
                  className="flex-1 md:flex-none px-6 py-2.5 bg-[#1A2B4A] text-white rounded-full text-sm font-semibold hover:bg-[#C9A961] transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  Accepter
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
